// Module
var code = " <gb-item-type ng-if=\"!$ctrl.item.show_label\" item=\"$ctrl.item\"> </gb-item-type> <span ng-if=\"$ctrl.item.show_label\" ng-bind=\"$ctrl.item.label\"> </span> ";
// Exports
export default code;